import React, { useMemo, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

import menuData from '../data/menuDrinks.json';
// --- 1. Import the new custom hook ---
import { useDragToScroll } from '../hooks/useDragToScroll';

const CategoryCircle = ({ category, product }) => {
  if (!product) return null;
  return (
    <Link to={`/menu#${category.toLowerCase().replace(/\s+/g, '-')}`} className="category-circle-link">
      <div className="category-circle">
        <div className="category-circle__image-wrapper">
          <img src={product.mainImage} alt={product.name} />
        </div>
        <h3 className="category-circle__name">{category}</h3>
      </div>
    </Link>
  );
};

const MenuSection = () => {
  // --- 2. Initialize the hook ---
  const { ref, onMouseDown, onMouseUp, onMouseLeave, onMouseMove } = useDragToScroll();

  const featuredCategories = useMemo(() => {
    const drinkCategories = new Set();
    const featured = [];
    menuData.menuDrinks.forEach(drink => {
      const isFood = ['Ftourat', 'Poke Bowls', 'Cakes', 'Breakfast & Pastries'].includes(drink.category);
      if (drink.category && !isFood && !drinkCategories.has(drink.category)) {
        drinkCategories.add(drink.category);
        featured.push({
          category: drink.category,
          product: drink
        });
      }
    });
    return featured;
  }, []);

  if (featuredCategories.length === 0) {
    return null;
  }

  return (
    <div className="menu-snippet-section">
      <header className="menu-snippet-section__header">
        <h2 className="menu-snippet-section__title">Menu by Category</h2>
        <Link to="/menu" className="menu-snippet-section__link">
          View Full Menu <ArrowRight size={16} />
        </Link>
      </header>

      {/* --- 3. Attach the ref and the event handlers to the carousel div --- */}
      <div 
        className="menu-snippet-section__carousel"
        ref={ref}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onMouseLeave={onMouseLeave}
        onMouseMove={onMouseMove}
      >
        <div className="menu-snippet-section__grid">
          {featuredCategories.map(({ category, product }) => (
            <CategoryCircle key={category} category={category} product={product} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default MenuSection;